import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d6da463&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=2d6da463&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6da463",
  null
  
)

export default component.exports